import Quote from "@/components/SVG/Quote";

const PatientVoices = () => {
    return (
        <div className="py-8 flex flex-col items-center gap-8">
            {/* Title */}
            <div className="text-center text-[#333333] dark:text-white text-4xl font-semibold font-satoshi uppercase">
                RTHM Patient Voices
            </div>

            {/* Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6">
                {/* Card 1 */}
                <div className="bg-accent rounded-2xl p-6 flex flex-col justify-between">
                    <div className="flex flex-col gap-5">
                        <Quote />
                        <p className="text-[#333333] dark:text-gray-200 text-lg font-normal font-satoshi leading-relaxed">
                            I lost years of my life feeling like I needed a
                            heart transplant. My doctors told me there
                            wasn&apos;t a medication that treated POTS and I
                            actually believed them! Until I found RTHM.
                        </p>
                    </div>
                    <div className="mt-4 flex gap-2 items-center text-sm">
                        <span className="text-[#666666] dark:text-gray-400 font-space">
                            Lauren
                        </span>
                        <span className="text-[#1a5b77] dark:text-blue-400 font-space">
                            @potszebra
                        </span>
                    </div>
                </div>

                {/* Card 2 */}
                <div className="bg-accent rounded-2xl p-6 flex flex-col justify-between">
                    <div className="flex flex-col gap-5">
                        <Quote />
                        <p className="text-[#333333] dark:text-gray-200 text-lg font-normal font-satoshi leading-relaxed">
                            RTHM has been a huge lifeline in a maze of finding
                            out what&apos;s happening to my life with Long COVID
                            and effective treatments for such complex, new
                            issues.
                        </p>
                    </div>
                    <div className="mt-4 flex justify-between items-center text-sm">
                        <span className="text-[#666666] dark:text-gray-400 font-space">
                            Jen C.
                        </span>
                    </div>
                </div>

                {/* Card 3 */}
                <div className="bg-accent rounded-2xl p-6 flex flex-col justify-between">
                    <div className="flex flex-col gap-5">
                        <Quote />
                        <p className="text-[#333333] dark:text-gray-200 text-lg font-normal font-satoshi leading-relaxed">
                            RTHM is peak healthcare and should be used as a
                            blueprint for a new standard of care all over. Thank
                            you for saving me.
                        </p>
                    </div>
                    <div className="mt-4 flex justify-between items-center text-sm">
                        <span className="text-[#666666] dark:text-gray-400 font-space">
                            Elizabeth G.
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PatientVoices;
